import { render } from "./FundStabe.vue?vue&type=template&id=d3aa6048"
import script from "./FundStabe.vue?vue&type=script&lang=js"
export * from "./FundStabe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__